import React, { Component } from 'react';
import { connect } from 'react-redux';
import loadingIcon from '../../../assets/images/loading.svg';
import { validarCiePelaUrl } from '../../../logicas/Validador/ValidadorApi';

class ValidacaoCie extends Component {
  componentWillMount() {
    const codigoUso = this.props.match.params.codigoUso;
    const dataNascimento = this.props.match.params.dataNascimento;
    const codigoUsoSplit = codigoUso.split('');

    if (window.location.href.indexOf('icp') < 0 && codigoUsoSplit.length === 8 && codigoUsoSplit[0] === "N"){
      window.location = `https://icp.cdne.com.br/val/${codigoUso}/${dataNascimento}`
    }
    new Promise(resolve => {
      this.props.validarCiePelaUrl(this.props.match.params);
      resolve()
    })
  }

  render() {
    console.log("PROPS::", this.props.validacaoStatus)
    const validacaoStatus = this.props.validacaoStatus;
    const statusUnique = validacaoStatus.statusUnique;
    const certificadoInfos = validacaoStatus.certificadoInfos;
    return (
      <div>
        <section className="py-5">
          <div className="meiaentrada-title mb-5">
            <div className="container">
              <div className="meiaentrada-title-border-hide">
                <h1>Validação de CIE <span className="small">(Carteira de Identificação Estudantil)</span></h1>
              </div>
            </div>
          </div>
          <div className="container">

            {statusUnique ?
              certificadoInfos ? (
                <div>
                  <div className="alert alert-success text-center" role="alert">
                    <h4 className="alert-heading my-3">Documento válido!</h4>
                  </div>
                  <div>
                    <div>
                      <p className='text-center'>
                        {certificadoInfos.entidade} atesta que {certificadoInfos.nomeSocial ? certificadoInfos.nomeSocial : certificadoInfos.nome} é estudante e está
                        regularmente matriculado(a) em {certificadoInfos.curso} da
                        instituição {certificadoInfos.instituicao}
                      </p>
                    </div>

                    <div className="row mb-5">
                      <div className='col-lg-10 col-md-8'>
                        {certificadoInfos.nome && 
                        <div className='row border border-left-0 border-right-0 py-2'>
                          <div className="col-md-3 text-md-right"><b>Nome:</b></div>
                          <div className="col-md-9">{certificadoInfos.nomeSocial ? certificadoInfos.nomeSocial : certificadoInfos.nome}</div>
                        </div>}

                        {certificadoInfos.instituicao &&
                        <div className='row border border-left-0 border-right-0 border-top-0 py-2'>
                          <div className="col-md-3 text-md-right"><b>Instituição:</b></div>
                          <div className="col-md-9">{certificadoInfos.instituicao}</div>
                        </div>}

                        {certificadoInfos.curso &&
                        <div className='row border border-left-0 border-right-0 border-top-0 py-2'>
                          <div className="col-md-3 text-md-right"><b>Curso:</b></div>
                          <div className="col-md-9">{certificadoInfos.curso}</div>
                        </div>}

                        {certificadoInfos.documento &&
                        <div className='row border border-left-0 border-right-0 py-2'>
                          <div className="col-md-3 text-md-right"><b>Documento de Identificação:</b></div>
                          <div className="col-md-9">{certificadoInfos.documento}</div>
                        </div>}

                        {certificadoInfos.entidade &&
                        <div className='row border border-left-0 border-right-0 border-top-0 py-2'>
                          <div className="col-md-3 text-md-right"><b>Emissor:</b></div>
                          <div className="col-md-9">{certificadoInfos.entidade}</div>
                        </div>}

                      </div>

                      <div className="col-4 mx-auto col-lg-2 col-md-4">
                        {certificadoInfos.foto &&
                        <img className='rounded' src={certificadoInfos.foto} alt={certificadoInfos.nomeSocial ? certificadoInfos.nomeSocial : certificadoInfos.nome}/>}
                      </div>

                    </div>

                    <h5>Certificado de Atributo em formato PEM:</h5>
                    <div className='certificate-container'>
                      <p className="text-center">
                        -----BEGIN CERTIFICATE-----
                      </p>

                      <span className="certificate">
                        {certificadoInfos.certificado}
                      </span>

                      <br/><br/>
                      <p className="text-center">
                        -----END CERTIFICATE-----
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="alert alert-danger text-center" role="alert">
                    <h4 className="alert-heading my-3">Documento inválido!</h4>
                  </div>
                </div>
              ) : (<div className="col text-center"><img src={loadingIcon} alt="Carregando"/></div> )}
          </div>
        </section>

      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    validacaoStatus: state.validacaoStatus
  }
};

const mapDispatchToProps = dispatch => {
  return {
    validarCiePelaUrl: (values) => {
      dispatch(validarCiePelaUrl(values))
    }
  }
};

const ValidacaoCieContainer = connect(mapStateToProps, mapDispatchToProps)(ValidacaoCie);

export default ValidacaoCieContainer


// WEBPACK FOOTER //
// ./src/components/views/Validador/ValidacaoCie.js